import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import PORTNUMBER from "../../constant/api";
import { useHistory, useLocation } from "react-router-dom";
import moment from "moment";
import socket from "../../helpers/Socket";

const Header = () => {
  const PORT = PORTNUMBER.PORTNUMBER;
  const ADMIN_LOGO_SRC = "/images/drotly-logo-light.png";

  const history = useHistory();
  const location = useLocation();
  const pathname = location.pathname;

  const allPathEdit = pathname.split("/");
  const [allAlerts, setAllAlerts] = useState([]);
  const [alertTotals, setAlertTotals] = useState({});
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const alertsLoadedRef = useRef(false);
  const [moreLoading, setMoreLoading] = useState(false);
  const [noMore, setNoMore] = useState({}); // { unread: true, read: true } once a tab is exhausted

  // The header is mounted on the login page too and login navigates without a reload, so load
  // alerts once a token exists (the alerts API is admin-only) instead of only on first mount.
  useEffect(() => {
    if (alertsLoadedRef.current || !localStorage.getItem("token")) return;
    alertsLoadedRef.current = true;
    fetchAlerts().catch(() => {
      alertsLoadedRef.current = false;
    });
  }, [pathname]);

  useEffect(() => {
    
    // Close dropdown when clicking outside
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    
    // Listen for real-time notifications
    socket.on("newAlert", (data) => {
      console.log("New alert received via socket:", data);
      setAlertTotals(prev => (prev.unread == null ? prev : { ...prev, unread: prev.unread + 1 }));
      setAllAlerts(prevAlerts => {
        const updatedAlerts = [data, ...prevAlerts];
        // Re-sort: unread first, then by time
        return updatedAlerts.sort((a, b) => {
          if (a.read === false && b.read === true) return -1;
          if (a.read === true && b.read === false) return 1;
          return new Date(b.time) - new Date(a.time);
        });
      });
    });
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      socket.off("newAlert");
    };
  }, []);

  const fetchAlerts = async () => {
    await axios.get(`${PORT}/getAllAdminAlerts`).then((response) => {
      if (response && response.data) {
        const sortedAlerts = response.data.data.sort((a, b) => {
          if (a.read === false && b.read === true) return -1;
          if (a.read === true && b.read === false) return 1;
          return new Date(b.time) - new Date(a.time);
        });
        setAllAlerts(sortedAlerts);
        setNoMore({});
        // The API sends only the latest alerts; these are the real totals.
        setAlertTotals({ unread: response.data.unreadCount, read: response.data.readCount });
      }
    });
  };

  // Flip locally instead of refetching so pages added by "Load more" are kept.
  const setReadState = async (id, read) => {
    try {
      const response = await axios.post(`${PORT}/${read ? "readAdminAlert" : "unreadAdminAlert"}`, { id });
      if (response.data && response.data.status === 'success') {
        setAllAlerts(prev => prev.map(a => (a._id === id ? { ...a, read } : a)));
        setAlertTotals(prev => (prev.unread == null ? prev : {
          unread: prev.unread + (read ? -1 : 1),
          read: prev.read + (read ? 1 : -1),
        }));
      }
    } catch (error) {
      console.error('Error updating alert:', error);
    }
  };
  const readAlertHandler = (id) => setReadState(id, true);
  const unreadAlertHandler = (id) => setReadState(id, false);

  const loadMore = async (tab) => {
    const tabAlerts = allAlerts.filter(a => (tab === 'read' ? a.read : !a.read));
    const oldest = tabAlerts[tabAlerts.length - 1];
    setMoreLoading(true);
    try {
      const { data } = await axios.get(`${PORT}/getAllAdminAlerts`, {
        params: { status: tab, limit: 20, before: oldest ? oldest.time : undefined },
      });
      const page = data?.data || [];
      setAllAlerts(prev => {
        const ids = new Set(prev.map(a => a._id));
        return [...prev, ...page.filter(a => !ids.has(a._id))];
      });
      if (!data?.hasMore) setNoMore(prev => ({ ...prev, [tab]: true }));
    } catch (error) {
      console.error('Error loading more alerts:', error);
    } finally {
      setMoreLoading(false);
    }
  };

  const unreadCount = alertTotals.unread ?? allAlerts.filter(alert => !alert.read).length;
  const readCount = alertTotals.read ?? allAlerts.filter(alert => alert.read).length;
  const [activeTab, setActiveTab] = useState('unread'); // 'unread' or 'read'

  const handleLogout = (event) => {
    event.preventDefault();
    localStorage.clear();
    history.push({ pathname: "/", customdata: { pathname } });
  };

  const handleMedia = () => {
    document.body.classList.add("overflow-none");
  };
  const sideHandle = () => {
    document.body.classList.add("hidemenu_title");
  };
  const sideRemove = () => {
    document.body.classList.remove("hidemenu_title");
  };

  const handleChangePassword = (event) => {
    event.preventDefault();
    history.push("/admin-change-password");
  };

  if (
    location.pathname === "/" ||
    location.pathname === "/forgetPassword" ||
    allPathEdit[1] === "confirmPassword"
  ) {
    return null;
  } else {
    return (
      <header class="header_head">
        <div class="header_inner">
          <div class="logomobil onlyfordesk">
            <a href="">
              <img src={ADMIN_LOGO_SRC} alt="Drotly" />
            </a>
          </div>
          <div class="tabicon_logo text-left">
            <a
              onClick={sideHandle}
              id="tabicon_menu"
              class="menutab_design numone_click"
            >
              <i class="fa fa-caret-left"></i>
              <i class="fa fa-caret-right"></i>
            </a>
            <a
              onClick={sideRemove}
              id="tabicon_menu02"
              class="menutab_design numtwo_click"
            >
              <i class="fa fa-caret-left"></i>
              <i class="fa fa-caret-right"></i>
            </a>
          </div>
          <div class="welcomadmin notification-list profile-dropdown">
            <a
              class="nav-link dropdown-toggle arrow-none waves-effect d-flex align-items-center"
              data-toggle="dropdown"
              href="#"
              role="button"
              aria-haspopup="false"
              aria-expanded="false"
            >
              <span class="symbol-label d-inline-flex align-items-center justify-content-center rounded-circle bg-white mr-2" style={{ width: "32px", height: "32px" }}>
                <i class="fa fa-user" style={{ fontSize: "14px", color: "#fe5f55" }}></i>
              </span>
              <span style={{ color: "#ffffff", fontSize: "12px", fontWeight: 600 }}>
                Admin
              </span>
              <i class="fa fa-angle-down ml-2" style={{ color: "#ffffff", fontSize: "12px" }}></i>
            </a>
            <div class="dropdown-menu dropdown-menu-right">
              <a
                href=""
                class="dropdown-item"
                onClick={handleChangePassword}
              >
                Change Password
              </a>
              <a href="" class="dropdown-item" onClick={handleLogout}>
                Log out
              </a>
            </div>
          </div>

          <div class="dropdown notification-list ntIcon" ref={dropdownRef} style={{ position: 'relative' }}>
            <a
              class="nav-link dropdown-toggle arrow-none waves-effect"
              href="#"
              role="button"
              onClick={(e) => {
                e.preventDefault();
                setShowDropdown(!showDropdown);
              }}
            >
              <i class="fa fa-bell"></i>
              {unreadCount > 0 && (
                <span className="noti-icon-badge" style={{
                  position: 'absolute',
                  top: '-10px',
                  right: '-12px',
                  backgroundColor: '#ff3b30',
                  color: '#fff',
                  borderRadius: '50%',
                  minWidth: '18px',
                  height: '18px',
                  fontSize: '10px',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '0 4px'
                }}>
                  {unreadCount > 99 ? '99+' : unreadCount}
                </span>
              )}
            </a>
            {showDropdown && (
            <div class="dropdown-menu dropdown-menu-right dropdown-menu-lg" style={{
              display: 'block',
              width: 'min(400px, 90vw)',
              maxHeight: 'min(500px, 80vh)',
              padding: 0,
              border: '1px solid #e0e0e0',
              borderRadius: '4px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
            }}>
              {/* Header */}
              <div style={{
                padding: '12px 16px',
                borderBottom: '1px solid #e0e0e0',
                backgroundColor: '#fafafa'
              }}>
                <div style={{
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#333',
                  marginBottom: '10px'
                }}>
                  Notifications
                </div>
                
                {/* Tabs */}
                <div style={{
                  display: 'flex',
                  borderBottom: '2px solid #e0e0e0'
                }}>
                  <button
                    onClick={() => setActiveTab('unread')}
                    style={{
                      flex: 1,
                      padding: '8px',
                      border: 'none',
                      borderBottom: activeTab === 'unread' ? '2px solid #4a90e2' : '2px solid transparent',
                      backgroundColor: 'transparent',
                      color: activeTab === 'unread' ? '#4a90e2' : '#666',
                      fontWeight: activeTab === 'unread' ? '600' : '400',
                      fontSize: '13px',
                      cursor: 'pointer',
                      marginBottom: '-2px',
                      transition: 'all 0.2s'
                    }}
                  >
                    Unread ({unreadCount})
                  </button>
                  <button
                    onClick={() => setActiveTab('read')}
                    style={{
                      flex: 1,
                      padding: '8px',
                      border: 'none',
                      borderBottom: activeTab === 'read' ? '2px solid #4a90e2' : '2px solid transparent',
                      backgroundColor: 'transparent',
                      color: activeTab === 'read' ? '#4a90e2' : '#666',
                      fontWeight: activeTab === 'read' ? '600' : '400',
                      fontSize: '13px',
                      cursor: 'pointer',
                      marginBottom: '-2px',
                      transition: 'all 0.2s'
                    }}
                  >
                    Read ({readCount})
                  </button>
                </div>
              </div>
              
              {/* Notification list */}
              <div style={{
                maxHeight: '400px',
                overflowY: 'auto',
                overflowX: 'hidden'
              }}>
                {(() => {
                  const filteredAlerts = activeTab === 'unread' 
                    ? allAlerts.filter(alert => !alert.read)
                    : allAlerts.filter(alert => alert.read);
                  
                  if (filteredAlerts.length === 0) {
                    return (
                      <div style={{
                        padding: '40px 20px',
                        textAlign: 'center',
                        color: '#999',
                        fontSize: '13px'
                      }}>
                        No {activeTab} notifications
                      </div>
                    );
                  }
                  
                  return [...filteredAlerts.map((alert, index) => (
                    <div
                      key={alert._id || index}
                      style={{
                        padding: '12px 16px',
                        borderBottom: '1px solid #f0f0f0',
                        backgroundColor: activeTab === 'unread' ? '#f8f9ff' : '#fff',
                        cursor: !alert.read ? 'pointer' : 'default',
                        transition: 'background-color 0.2s',
                        opacity: alert.read ? 0.8 : 1
                      }}
                      onMouseEnter={(e) => {
                        if (!alert.read) e.currentTarget.style.backgroundColor = '#f5f5f5';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = activeTab === 'unread' ? '#f8f9ff' : '#fff';
                      }}
                    >
                      {/* Type, indicator and time */}
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '6px'
                      }}>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          flex: 1,
                          minWidth: 0
                        }}>
                          {activeTab === 'unread' && (
                            <div style={{
                              width: '8px',
                              height: '8px',
                              borderRadius: '50%',
                              backgroundColor: '#4a90e2',
                              flexShrink: 0
                            }}></div>
                          )}
                          <span style={{
                            fontSize: '13px',
                            fontWeight: activeTab === 'unread' ? '600' : '400',
                            color: '#333',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }}>
                            {alert.type}
                          </span>
                        </div>
                        <span style={{
                          fontSize: '11px',
                          color: '#999',
                          whiteSpace: 'nowrap',
                          marginLeft: '8px',
                          flexShrink: 0
                        }}>
                          {moment(alert.time).fromNow(true)} ago
                        </span>
                      </div>
                      
                      {/* Message and icon */}
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start'
                      }}>
                        <p style={{
                          margin: 0,
                          fontSize: '12px',
                          color: '#666',
                          lineHeight: '1.5',
                          flex: 1,
                          minWidth: 0,
                          marginRight: '12px',
                          whiteSpace: 'normal',
                          overflowWrap: 'anywhere'
                        }}>
                          {alert.message}
                        </p>
                        
                        {/* Action icon on right side */}
                        {activeTab === 'unread' ? (
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              readAlertHandler(alert._id);
                            }}
                            style={{
                              width: '28px',
                              height: '28px',
                              borderRadius: '50%',
                              backgroundColor: '#f0f7ff',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              cursor: 'pointer',
                              flexShrink: 0,
                              transition: 'background-color 0.2s'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e0f0ff'}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
                            title="Mark as read"
                          >
                            <i className="fa fa-check" style={{ color: '#4a90e2', fontSize: '14px' }}></i>
                          </div>
                        ) : (
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              unreadAlertHandler(alert._id);
                            }}
                            style={{
                              width: '28px',
                              height: '28px',
                              borderRadius: '50%',
                              backgroundColor: '#f0f7ff',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              cursor: 'pointer',
                              flexShrink: 0,
                              transition: 'background-color 0.2s'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e0f0ff'}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
                            title="Mark as unread"
                          >
                            <i className="fa fa-envelope" style={{ color: '#4a90e2', fontSize: '14px' }}></i>
                          </div>
                        )}
                      </div>
                    </div>
                  )),
                  (activeTab === 'unread' ? unreadCount : readCount) > filteredAlerts.length && !noMore[activeTab] && (
                    <div key="load-more" style={{ padding: '10px 16px', textAlign: 'center' }}>
                      <button
                        onClick={() => loadMore(activeTab)}
                        disabled={moreLoading}
                        style={{
                          border: '1px solid #4a90e2', background: '#fff', color: '#4a90e2',
                          borderRadius: '16px', padding: '6px 18px', fontSize: '12px', fontWeight: 600,
                          cursor: moreLoading ? 'default' : 'pointer', opacity: moreLoading ? 0.6 : 1
                        }}
                      >
                        {moreLoading ? 'Loading…' : 'Load more'}
                      </button>
                    </div>
                  )];
                })()}
              </div>
            </div>
            )}
          </div>

          <div class="icon_mail">
            <a href="/email-templates">
              <i class="fa fa-envelope"></i>
            </a>
          </div>
          <div class="menuformob onlyfordesk">
            <a onClick={handleMedia} id="filter-toggler">
              <i class="fa fa-bars"></i>
            </a>
          </div>
        </div>
      </header>
    );
  }
};

export default Header;
